import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import { browserHistory } from 'react-router';
import createSagaMiddleware from 'redux-saga';
import thunk from 'redux-thunk';
import * as Sentry from '@sentry/react';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import {
  ReducerRegistry,
  SagaRegistry,
  setUnsafeGlobalInstance,
} from 'mf-config/client';

import { createReducers, reducerMap } from '../../reducers/root';
import rootSaga from '../../sagas/root';

function createReduxStore() {
  const sagaMiddleware = createSagaMiddleware();
  const middlewares = [routerMiddleware(browserHistory), sagaMiddleware, thunk];
  const reducerRegistry = new ReducerRegistry(reducerMap);

  const sentryReduxEnhancer = Sentry.createReduxEnhancer();

  const composeEnhancers = composeWithDevTools({
    serialize: {
      error: true,
    },
  });

  const store = createStore(
    createReducers(reducerRegistry?.getReducers()),
    composeEnhancers(applyMiddleware(...middlewares), sentryReduxEnhancer)
  );

  const sagaRegistry = new SagaRegistry(sagaMiddleware, rootSaga);

  // Listen for store changes
  reducerRegistry.setChangeListener((reducers) => {
    store.replaceReducer(createReducers(reducers));

    return Promise.resolve(true);
  });

  setUnsafeGlobalInstance('reducerRegistry', reducerRegistry);
  setUnsafeGlobalInstance('sagaRegistry', sagaRegistry);

  return store;
}

export default createReduxStore;
